/* eslint-disable @angular-eslint/directive-selector */

import { Directive, Input, TemplateRef } from '@angular/core'
import { TemplateStoreService } from '../services/template-store.service'

@Directive({
  selector: '[appTemplateKey]'
})
export class TemplateKeyDirective {
  private _key: string

  constructor(
    private readonly template: TemplateRef<Record<string, unknown>>,
    private readonly templateStoreService: TemplateStoreService
  ) {}

  @Input('appTemplateKey')
  public set key(value: string) {
    this._key = value
    this.templateStoreService.add(value, this.template)
  }

  public get key (): string {
    return this._key
  }
}
